/**
 * Check if an agency user is subscribed.
 * Broad agency subscription signal for routing (not the same as billing recovery /
 * Stripe past_due, which lives in agencyBillingRecoveryRedirect).
 *
 * @param {Object} user - User object from store
 * @returns {boolean} - True if user is subscribed
 */
export function isAgencySubscribed(user) {
  if (!user || user.role !== 'Agency' || !user.agency) {
    return false
  }

  if (user.agency.free_fee) {
    return true
  }

  if (user.subscribed) {
    return true
  }

  if (user.user_plans && Array.isArray(user.user_plans)) {
    return user.user_plans.some((plan) => !plan.past_due)
  }

  return false
}

/**
 * Check if user has access to a specific product
 * @param {Object} user - User object from store
 * @param {string} productType - Product type to check (e.g., 'ReplyEngine', 'SocialReview')
 * @returns {boolean} - True if user has access to the product
 */
export function hasProductAccess(user, productType) {
  if (!user || !user.agency) {
    return false
  }

  if (user.agency.free_fee) {
    return true
  }

  if (user.user_plans && Array.isArray(user.user_plans)) {
    return user.user_plans.some((plan) => {
      return (
        !plan.past_due &&
        (plan.plan.product_type === productType ||
          (Array.isArray(plan.plan.planProducts) &&
            plan.plan.planProducts.includes(productType)))
      )
    })
  }

  return false
}
